/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a signature you can drop into documents, contracts and emails. Draw it freehand or type your name in a handwriting style, then download it as a transparent PNG.`)
};

const es_sig_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una firma que puedas insertar en documentos, contratos y correos electrónicos. Dibújala a mano alzada o escribe tu nombre en un estilo de escritura manual, luego descárgalo como PNG transparente.`)
};

const de_sig_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie eine Signatur, die Sie in Dokumente, Verträge und E-Mails einfügen können. Zeichnen Sie sie freihand oder geben Sie Ihren Namen in einer Handschriftart ein, und laden Sie sie dann als transparentes PNG herunter.`)
};

const nl_sig_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een handtekening die u in documenten, contracten en e-mails kunt plaatsen. Teken het uit de vrije hand of typ uw naam in een handschriftstijl, en download het vervolgens als transparante PNG.`)
};

const fr_sig_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez une signature que vous pouvez insérer dans des documents, des contrats et des e-mails. Dessinez-la à main levée ou tapez votre nom dans un style manuscrit, puis téléchargez-la en tant que PNG transparent.`)
};

const it_sig_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una firma che puoi inserire in documenti, contratti ed email. Disegnala a mano libera o digita il tuo nome in uno stile calligrafico, poi scaricala come PNG trasparente.`)
};

const pt_br2_sig_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie uma assinatura que você possa inserir em documentos, contratos e emails. Desenhe à mão livre ou digite seu nome em um estilo cursivo, depois baixe como PNG transparente.`)
};

const pt_sig_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie uma assinatura que possa inserir em documentos, contratos e emails. Desenhe-a manualmente ou escreva o seu nome com estilo de caligrafia, depois descarregue como PNG transparente.`)
};

const ja_sig_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドキュメント、契約書、メールに落とし込める署名を作成します。手書きで描くか、手書きスタイルで名前を入力してから、透明なPNGとしてダウンロードします。`)
};

const zh_sig_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建可放入文档、合同和电子邮件的签名。手绘或用笔迹风格输入您的名字，然后将其下载为透明 PNG。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_hub_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_hub_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_hub_intro", locale)
	if (locale === "en") return en_sig_hub_intro(inputs)
	if (locale === "es") return es_sig_hub_intro(inputs)
	if (locale === "de") return de_sig_hub_intro(inputs)
	if (locale === "nl") return nl_sig_hub_intro(inputs)
	if (locale === "fr") return fr_sig_hub_intro(inputs)
	if (locale === "it") return it_sig_hub_intro(inputs)
	if (locale === "pt-BR") return pt_br2_sig_hub_intro(inputs)
	if (locale === "pt") return pt_sig_hub_intro(inputs)
	if (locale === "ja") return ja_sig_hub_intro(inputs)
	return zh_sig_hub_intro(inputs)
};